// extracted by mini-css-extract-plugin
export default {"newProjectButton":"UserSection_newProjectButton__rExvS","userName":"UserSection_userName__H9YRv"};